import { blue } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';

type Props = {
  isAnd: boolean;
};

export function GatewayRuleGroupIsAnd({ isAnd }: Props): JSX.Element {
  const translate = useTypedTranslate();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: '8px 0px',
        width: '32px',
        height: '32px',
        backgroundColor: blue[50],
        borderColor: blue[700],
        color: blue[700],
        borderRadius: '4px',
        fontSize: '13px',
        borderWidth: '1px',
        borderStyle: 'solid',
        textTransform: 'lowercase',
      }}
    >
      {isAnd ? translate('app.common.and') : translate('app.common.or')}
    </Box>
  );
}
